import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, TextInput } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'
import IconButton from '../../../internal/IconButton'
import { actOnData, getDeepOr } from '../../../util/helpers'
import { FormSelect } from '../../../pages/PayApply/pages/ApplicationFormPage/FormSelect'
import styles from './filter.module.scss'
import { getText } from '../../../internal/TextLabels'
import { Roles } from '../../../models/roles'
import {GAActions} from '../../../util/analytics';

const getValueTranslation = (translations, v) =>
  translations ? getText(translations[v]) : v

const Filter = props => {
  const [field, setField] = useState('')
  const [value, setValue] = useState('')
  const [active, setActive] = useState(false)
  const [filters, setFilters] = useState([])
  const [currentFilter, setCurrentFilter] = useState({})
  useEffect(
    () => {
      if (field) {
        setCurrentFilter(filters.find(f => f.value === field))
      }
    },
    [field, filters],
  )

  useEffect(
    () => {
      setFilters(
        Object.values(props.values)
          .filter(
            f =>
              props.userRole === Roles.RESURS_ADMIN ||
              f.role !== Roles.RESURS_ADMIN,
          )
          .map(f => ({
            ...f,
            key: f.value,
            value: f.value,
            valueLabel: getText(f.name),
          })),
      )
    },
    [props.userRole],
  )

  if (props.filter && !active) {
    const { valueTranslations, name } = props.values[props.filter.field]
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'right',
        }}
      >
        <p style={{ marginLeft: 'auto' }}>
          {`${getText(name)} ${getText('filters.is')} ${getValueTranslation(
            valueTranslations,
            props.filter.value,
          )}`}
        </p>
        <IconButton
          icon="midasMinus3"
          onClick={() => props.onRemove(props.filter)}
          onSubmit={e => e.preventDefault()}
          tabIndex={-1}
        />
      </div>
    )
  }
  if (!active) {
    return (
      <div className={styles.container}>
        <Button
          size="small"
          type="link"
          onClick={() => {
            props.onGAEvent(GAActions.IMPRESSION)
            setActive(true)
          }}
          dataCy="filter-add-button"
        >
          {getText('filters.addFilter')}
        </Button>
      </div>
    )
  }

  const getValues = arr =>
    arr.map(v => {
      if (v instanceof Object) {
        return {
          key: v.value,
          value: v.value,
          valueLabel: getText(v.label),
        }
      }
      return {
        key: v,
        value: `${v}`,
        valueLabel: `${getValueTranslation(
          currentFilter.valueTranslations,
          v,
        )}`,
      }
    })

  return (
    <div className={styles.container}>
      <FormSelect
        id="filter-field-select"
        values={filters}
        defaultValue={field}
        isValid={() => true}
        onChange={val => {
          setValue('')
          setField(val)
        }}
        dataCy="filter-field-select"
      />
      <Conditional
        when={!!currentFilter}
        then={() =>
          actOnData(
            currentFilter.values ||
              (currentFilter.dataset &&
                getDeepOr([], props.data, currentFilter.dataset)),
            arr => (
              <FormSelect
                disabled={arr.length === 0}
                id="filter-value-select"
                values={getValues(arr)}
                isValid={() => true}
                {...(value && {
                  defaultValue: value,
                }) || { optionsLabel: ' ' }}
                onChange={setValue}
                dataCy="filter-value-select"
              />
            ),
          ) || (
            <TextInput
              id="filter-value-input"
              type="text"
              skipValidation
              value={value}
              onChange={e => setValue(e.target.value)}
            />
          )
        }
      />
      <div>
        <Button
          size="small"
          disabled={!field || value === ''}
          onClick={() => {
            props.onSave({
              field,
              type: 'MUST',
              value,
            })
            setActive(false)
          }}
        >
          {getText('filters.add')}
        </Button>
        <Button
          size="small"
          type="link"
          onClick={() => {
            props.onGAEvent(GAActions.CANCEL)
            setActive(false)
          }}
        >
          {getText('filters.cancel')}
        </Button>
      </div>
    </div>
  )
}

Filter.propTypes = {
  data: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  userRole: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  filter: PropTypes.object,
  values: PropTypes.object.isRequired,
  onGAEvent: PropTypes.func,
}

Filter.defaultProps = {
  filter: null,
  onRemove: () => {},
  onGAEvent: () => {},
}

const mapStateToProps = state => ({
  data: state.statistics,
  userRole: state.auth.role,
})

export default connect(
  mapStateToProps,
  null,
)(Filter)
